module.exports = __webpack_public_path__ + "static/media/s_black.69c07b1b.mp3";